import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactMailingList from "./ContactMailingList";
import type MediaRelease from "./MediaRelease";

@Model()
class MediaReleasesContactMailingList extends ApplicationRecord {
  static jsonapiType = "media_releases_contact_mailing_lists";

  @BelongsTo() contactMailingList: ContactMailingList;

  @Attr() contactMailingListId: number;

  @BelongsTo() mediaRelease: MediaRelease;

  @Attr() mediaReleaseId: number;
}

export default MediaReleasesContactMailingList;
